import $ from 'jquery';
import MapStyle from './mapStyle';

class MapLoader {
	constructor() {
		this.style = new MapStyle();
		this.events();
	}

	events() {
		var $map = $('#map');

		window.init = () => {
			const that = this;
			var locations = window.markerLocations,
				mapOptions = {
					zoom: 7,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					mapTypeControl: false,
					streetViewControl: false,
					overviewMapControl: false,
					scrollwheel: false,
					draggable: true,
					styles: that.style,
					center:	new google.maps.LatLng(52.310233, -1.635590)
				},
				map,
				infowindow = new google.maps.InfoWindow();

			if (typeof(window.mapOptions) === 'object') {
				mapOptions = $.extend(mapOptions, window.mapOptions);
			}

			map = new google.maps.Map(document.getElementById('map'), mapOptions);

			if (locations) {
				for (var i = 0; i < locations.length; i++) {
					var location = locations[i],
						position = new google.maps.LatLng(parseFloat(location.lat), parseFloat(location.lng)),
						marker = new google.maps.Marker({
							map: map,
							position: location
						});

						if (location.type) {
							marker.setIcon('/vendor/boomcms/themes/th/img/icons/' + location.type + '.png');
						}

						if (typeof(location.url) !== 'undefined') {
							marker.data = location;

							marker.addListener('click', function() {
								var l = this.data;

								infowindow.setContent("<a class='map-window' href='" + l.url + "'><div><h3>" + l.title + "</h3><p>" + l.text + "</p></div><span class='image' style='background-image: url(/asset/" + l.image + "/view/300)'></span></a>");
								infowindow.open(map, this);
							});
						}
				};

				if (locations.length === 1) {
					map.setCenter(position);
				}
			}
		}

		if ($map.length) {
			var script = document.createElement("script");
			script.type = "text/javascript";
			script.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyBMY5y_G_ixSTYosCBx4wxXxhW96v-4PqI&callback=init";
			document.body.appendChild(script);
		}
	}
}

export default {
	init() {
		new MapLoader();
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/mapLoader.js